import * as HeroStyles from '../dotdotdot/DotDotDotField.scss';
import * as React from 'react';
import { IconButton, ButtonType } from 'office-ui-fabric-react/lib/Button';

export interface IShareHeroFieldProps {
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  ariaLabel?: string;
  title?: string;
}

export const ShareHeroField: React.StatelessComponent<IShareHeroFieldProps> = (props: IShareHeroFieldProps) => {
  let { onClick, isDisabled, ariaLabel, title } = props;

  if (!isDisabled) {
    isDisabled = false;
  }
  return (
    <IconButton
      className={ `${HeroStyles.heroButton}` }
      onClick={ onClick }
      buttonType={ ButtonType.hero }
      aria-label={ ariaLabel }
      aria-haspopup='true'
      data-automationid='FieldRender-ShareHero'
      iconProps={
        { iconName: 'Share' }
      }
      title={ title }
    />
  );
};
